module.exports = __webpack_public_path__ + "static/fondoLandingHome-27f7377dbdaaf4d89854766299a6dddf.png";